import React, { useState } from 'react';
import { toast } from 'react-toastify';
import CustomButton from '../../custom/custom-button/CustomButton';
import CustomInput from '../../custom/custom-input/CustomInput';
import styles from "../common.module.scss";
import { User } from '../../../services';

const NewPasswordComponent = ({ data, updateStep, setData }) => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [invalidPassword, setInvalidPassword] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const validatePassword = (password) => {
        if (!password) {
            return "Поле не должно быть пустым";
        }
        if (password.length < 4) {
            return "Создайте надежный пароль";
        }
        return false;
    };

    const checkPasswordsMatch = () => {
        if (newPassword !== confirmPassword) {
            return "Пароли не совпадают";
        }
        return false;
    };

    const nextStep = () => {
        const passwordErrors = validatePassword(newPassword) || checkPasswordsMatch();
        if (passwordErrors) {
            setInvalidPassword(passwordErrors);
            return;
        }
        setIsLoading(true);

        const resetData = {
            email: data.userEmail,
            password: newPassword,
            confirmPassword: confirmPassword,
            code: data.code
        };

        User.resetPassword(resetData)
            .then(response => {
                if (response.data.isSuccess === true) {
                    toast.success("Пароль успешно сброшен!");
                    updateStep(4);
                    setData({ ...data, password: newPassword });
                    setIsLoading(false);
                } else {
                    toast.error("Ошибка при сбросе пароля.");
                    setIsLoading(false);
                }
            })
            .catch(error => {
                toast.error("Ошибка при сбросе пароля: " + error.message);
                setIsLoading(false);
            });
    };

    return (
        <>
            <div className={styles.card_form}>
                <CustomInput labelText="Новый пароль" placeholder="Введите пароль" isPasswordEye={true} onChangeValue={setNewPassword} value={newPassword} errorText={invalidPassword} />
                <CustomInput labelText="Повторите пароль" placeholder="Введите пароль" isPasswordEye={true} onChangeValue={setConfirmPassword} value={confirmPassword} errorText={invalidPassword} />
            </div>

            <div className={styles.btns}>
                <CustomButton isFall text="Сохранить" onClick={nextStep} isLoading={isLoading} />
            </div>
        </>
    );
}

export default NewPasswordComponent;
